import { Component, EventEmitter, Output } from '@angular/core';
import { NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { showErrorSwal } from '@asamco/utils';
import Swal from 'sweetalert2';
import { ApplicationLogin } from '../../interfaces/application-login.interface';
import { ApplicationLoginService } from '../../services/application-login.service';

@Component({
	selector: 'al-link-edit-application-login-article-admin',
	standalone: true,
	imports: [NgIf, FormsModule],
	templateUrl: './link-edit-application-login-article-admin.component.html',
	styleUrls: ['./link-edit-application-login-article-admin.component.scss'],
})
export class LinkEditApplicationLoginArticleAdminComponent {
	@Output() articlesSaved = new EventEmitter<{appLogin: ApplicationLogin, appSide: string}>();

	public visible = false;
	public saving = false;
	public appSide: string;
	public articleIdsText = '';
	public applicationName = '';

	private login: ApplicationLogin | null = null;

	constructor(private appLoginService: ApplicationLoginService) {}

	public open(login: ApplicationLogin, appSide: string, linkId: number, applicationName?: string): void {
		if (!login?.id) return;

		this.login = { ...login };
		this.appSide = appSide;
		this.applicationName = applicationName ?? login.name ?? '';
		this.articleIdsText = (login.freshdeskArticleIds ?? []).join(', ');
		this.visible = true;
	}

	public close(): void {
		this.visible = false;
		this.saving = false;
	}

	public save(): void {
		if (!this.login?.id) return;

		this.saving = true;

		const updatedLogin: ApplicationLogin = {
			...this.login,
			freshdeskArticleIds: this.parseArticleIds(this.articleIdsText),
		};

		this.appLoginService.updateLoginArticles(updatedLogin.id, updatedLogin.freshdeskArticleIds ?? []).subscribe({
			next: result => {
				this.saving = false;

				if (!result?.success) return;

				this.articlesSaved.emit({ appLogin: updatedLogin, appSide: this.appSide });
				this.close();
				Swal.fire({ icon: 'success', text: 'Linked articles updated.' });
			},
			error: error => {
				this.saving = false;
				showErrorSwal(error);
			},
		});
	}

	private parseArticleIds(input: string | null | undefined): number[] {
		return Array.from(
			new Set(
				(input ?? '')
					.split(/[\s,;]+/g)
					.map(value => value.trim())
					.filter(Boolean)
					.map(value => Number(value))
					.filter(value => Number.isFinite(value) && value > 0)
			)
		);
	}
}

